/* Elemence Shop — per-card purchase module.
   Each .elemence-product-card has a <script type="application/json"> child:
     { sizes: [{ id, label, days_label, badge, default_selected,
                 variant_id, one_time_price, sub_price, selling_plan_id }, ...] }
   State: { sizeId, mode: 'one' | 'sub' } stored on the DOM element.
   On change → re-render prices on rows + CTA + summary; sync the cart form. */
(function () {
  const maxSavingsPct = (sizes) => {
    const pcts = sizes
      .filter((s) => s.selling_plan_id != null && s.one_time_price > 0 && s.sub_price != null && s.sub_price < s.one_time_price)
      .map((s) => ((s.one_time_price - s.sub_price) / s.one_time_price) * 100);
    if (pcts.length === 0) return 0;
    return Math.round(Math.max.apply(null, pcts));
  };

  function initCard(card) {
    if (card.dataset.shopInit === '1') return;
    card.dataset.shopInit = '1';

    const dataEl = card.querySelector('script.elemence-product-card__data');
    if (!dataEl) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.sizes || data.sizes.length === 0) return;

    const labels = Object.assign({
      cta_onetime: 'Add to Cart',
      cta_subscribe: 'Start Ritual',
      per_month: '/mo',
      save_message: 'SUBSCRIBE AND SAVE UP TO [pct]%',
    }, data.labels || {});

    const anySub = data.sizes.some((s) => s.selling_plan_id != null);
    const savePct = maxSavingsPct(data.sizes);

    const defaultSize = data.sizes.find((s) => s.default_selected) || data.sizes[0];
    let state = { sizeId: defaultSize.id, mode: anySub ? 'sub' : 'one' };

    const modeEl = card.querySelector('.elemence-purchase__mode');
    const oneBtn = card.querySelector('[data-mode-target="one"]');
    const subBtn = card.querySelector('[data-mode-target="sub"]');
    const rows   = card.querySelectorAll('.elemence-purchase__row');
    const cta    = card.querySelector('.elemence-purchase__cta');
    const summary = card.querySelector('.elemence-purchase__summary');
    const form   = card.querySelector('form.elemence-purchase__form');
    const idIn   = form ? form.querySelector('input[name="id"]') : null;
    const spIn   = form ? form.querySelector('input[name="selling_plan"]') : null;

    if (!anySub && subBtn) {
      subBtn.disabled = true;
      subBtn.setAttribute('aria-disabled', 'true');
    }

    const priceFor = (size) => {
      if (state.mode === 'sub' && size.selling_plan_id != null && size.sub_price != null) {
        return size.sub_price;
      }
      return size.one_time_price;
    };

    const render = () => {
      const size = data.sizes.find((s) => s.id === state.sizeId) || data.sizes[0];
      const isSubMode = state.mode === 'sub';

      modeEl.setAttribute('data-mode', state.mode);
      if (oneBtn) oneBtn.classList.toggle('on', state.mode === 'one');
      if (subBtn) subBtn.classList.toggle('on', state.mode === 'sub');

      rows.forEach((row) => {
        const id = row.getAttribute('data-size-id');
        const s  = data.sizes.find((x) => x.id === id);
        if (!s) return;
        row.classList.toggle('active', id === state.sizeId);

        const nowEl = row.querySelector('.elemence-purchase__price-now');
        const wasEl = row.querySelector('.elemence-purchase__price-was');
        const rowIsSub = isSubMode && s.selling_plan_id != null && s.sub_price != null;
        const rowPrice = rowIsSub ? s.sub_price : s.one_time_price;

        // Pre-formatted by Liquid (`money` filter) — already market-aware.
        const rowPriceStr = rowIsSub ? (s.sub_price_formatted || '') : (s.one_time_price_formatted || '');
        if (nowEl) {
          if (rowPrice == null || !rowPriceStr) {
            nowEl.textContent = '';
          } else {
            nowEl.innerHTML = rowPriceStr
              + (rowIsSub ? '<span class="elemence-purchase__price-mo elemence-purchase__atc-mo"> ' + labels.per_month + '</span>' : '');
          }
        }
        if (wasEl) {
          const showWas = rowIsSub && s.one_time_price > s.sub_price;
          wasEl.hidden = !showWas;
          wasEl.textContent = showWas ? (s.one_time_price_formatted || '') : '';
        }
      });

      const isCurSub = isSubMode && size.selling_plan_id != null && size.sub_price != null;
      const curPrice = priceFor(size);
      const curPriceStr = isCurSub ? (size.sub_price_formatted || '') : (size.one_time_price_formatted || '');
      if (cta) {
        cta.disabled = size.variant_id == null;
        const label = isCurSub ? labels.cta_subscribe : labels.cta_onetime;
        const moSuffix = isCurSub ? '<span class="elemence-purchase__price-mo elemence-purchase__atc-mo"> ' + labels.per_month + '</span>' : '';
        cta.innerHTML = label + ' · ' + (curPrice == null || !curPriceStr ? '' : curPriceStr + moSuffix);
      }

      if (summary) {
        const head = '<div>' + (size.label || '') + (size.days_label ? ' · ' + size.days_label : '') + '</div>';
        const saveLine = (isCurSub && savePct > 0)
          ? '<div class="save">' + labels.save_message.replace('[pct]', savePct) + '</div>'
          : '';
        summary.innerHTML = head + saveLine;
      }

      if (idIn) idIn.value = size.variant_id || '';
      if (spIn) spIn.value = (isCurSub ? size.selling_plan_id : '') || '';
    };

    if (oneBtn) oneBtn.addEventListener('click', () => { state.mode = 'one'; render(); });
    if (subBtn) subBtn.addEventListener('click', () => { if (anySub) { state.mode = 'sub'; render(); } });

    rows.forEach((row) => {
      row.addEventListener('click', () => {
        const id = row.getAttribute('data-size-id');
        if (id) { state.sizeId = id; render(); }
      });
    });

    render();
  }

  function initAll(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.elemence-product-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
